<template>
  <div class="main_navbar_tlr" style="border:none;">
    <div class="left_menu">
      <div class="nav_btn" @click="fun_togger_left" title="折叠菜单">
        <i :class="`${menu_bar.size=='full'?'el-icon-s-fold':'el-icon-s-unfold'} ficon`"></i>
      </div>
      <div class="breadcrumb">{{level1}}<template v-if="level2.length>0"> <i class="el-icon-arrow-right"></i>{{level2}}</template></div>
    </div>
    <div class="right_menu">
      <div class="nav_user" @click="fun_open_setting">
        <img src="@/assets/images/headimage.png" />
        <span class="user_name">{{current_user.userName}}</span>
        <span class="user_ip">{{ip}}</span>
      </div>
      <div class="nav_hover" @click="fun_open_setting"><i class="el-icon-setting ficon"></i></div>
      <div class="nav_hover" @click="fun_togger_fullscreen"><i class="el-icon-full-screen ficon"></i></div>
    </div>
    <CompSetting v-if="dialog_setting.show" :dialog="dialog_setting"></CompSetting>
    <ChangePasswordForm v-if="dialog.show" :dialog="dialog"></ChangePasswordForm>
  </div>
</template>

<script>
import ChangePasswordForm from '@/components/common/ChangePasswordForm.vue'
import CompSetting from "@/components/CompSetting.vue";
import breadcrumb from "../../components/common/Breadcrumb.vue";

export default {
  props:['menu_bar'],
  components: {
    CompSetting,
    ChangePasswordForm
  },
  data() {
    return {
      dialog: {show:false},
      dialog_setting:{show:false},
      cur: 0,
      current_user: {},
      menus:{rows:[]},
      common_sys_name:'',
      current_code:'',
      level1:'Dashboard',
      level2:'',
      ip:'0.0.0.0',
      links:[
        {link:'/back/weigh/monitor', level1:'过磅监控0',level2:''},
        {link:'/back/weigh/monitor1',level1:'过磅监控1',level2:''},
        {link:'/back/weigh/monitor2',level1:'过磅监控2',level2:''},
        {link:'/back/dashboard',level1:'Dashboard',level2:''},
      ],
    };
  },
  methods: {
    fun_togger_left(){
      this.menu_bar.size=this.menu_bar.size=='full'?'mini':'full';
      localStorage.setItem('left_menu_bar',this.menu_bar.size);
    },
    fun_open_setting(){Object.assign(this.dialog_setting,{show:!this.dialog_setting.show});},
    fun_togger_fullscreen(){
      if(document.fullscreenElement) document.exitFullscreen();
      else document.documentElement.requestFullscreen();
    },
    to_page(_path){
      this.$router.push(_path);
    },
    async logout() {
      await this.$store.dispatch('logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      location.reload()
    },
    openChangePW() {
      this.dialog.show = true;
    },
    close() {
      this.dialog.show = false;
      this.$refs['form'].resetFields();
    },
    randomAva() {
      this.user = this.$store.state.user.id + '';
      let newUser = this.user.substring(this.user.length - 1, this.user.length);
      this.menus = {rows:JSON.parse(localStorage.getItem('vue_store_menu'))};
    },
    fun_get_parent(_c){
      var _this = this;
      this.$store.state.menu.rows.forEach(n=>{
        if(n.levelCode.length!=3)return;
        if(!_c.levelCode.startsWith(n.levelCode))return;
        this.level1 = n.resourceName;
      });
    },
    fun_calc_breadcrumb(){
      var _this = this;
      if(this.$store.state.menu.rows<=0) this.$store.dispatch('reloadMenu')
      this.$store.state.menu.rows.forEach(n=>{
        if(n.url!=this.$route.fullPath) return;
        this.level2 = n.resourceName;
        this.fun_get_parent(n);
      });

      this.links.forEach(n=>{
        if(n.link!=_this.$route.fullPath) return;
        _this.level1=n.level1;
        _this.level2=n.level2;
      })
      _this.ip = 'null'==localStorage.getItem('client_ip')+""?'0.0.0.0':localStorage.getItem('client_ip');
    },
  },
  mounted() {
    var _this = this;
    this.current_user = this.$store.state.user;
    this.randomAva();
    this.common_sys_name = process.env.VUE_APP_SYSTEM_NAME;
    document.title = this.common_sys_name;

    this.menu_bar.size = localStorage.getItem('left_menu_bar')+''=='null'?'full':localStorage.getItem('left_menu_bar');

    _this.fun_calc_breadcrumb();
    _this.$watch('$route', (to, from) => {
      _this.fun_calc_breadcrumb();
    });
  },
};
</script>

<style scoped>
</style>
